import clsx from 'clsx'
import React from 'react'
import useStyles from './_styles'
import { PageContentProps } from './_props'

const PageContent = ({ children, className }: PageContentProps) => {
    const classes = useStyles()
    return <div className={clsx(classes.PageContent, className)}>{children}</div>
}

export default PageContent
